<template>
  <v-row>
    <v-col cols="12" class="pb-0">
      <v-data-table
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          'items-per-page-text': 'Inscrições por página',
        }"
        :headers="headers"
        :items-per-page="10"
        :items="inscricoes"
        :loading="loading"
        loading-text="Carregando inscrições..."
        class="elevation-1"
        disable-sort
        no-results-text="Nenhuma inscrição encontrada"
      >
        <template v-slot:item="{ item: inscricao }">
          <tr :key="inscricao.id">
            <td>
              <span class="d-flex align-center">
                {{ inscricao.matricula.unidadeEnsino.nomeCompleto }}
              </span>
            </td>
            <td>
              <span class="d-flex align-center justify-center">
                {{ inscricao.matricula.etapa.nome }}
              </span>
            </td>
            <td>
              <span class="d-flex align-center justify-center">
                {{ inscricao.matricula.pessoa.cpf_cnpj }}
              </span>
            </td>
            <td>
              <span class="d-flex align-center justify-center">
                {{ inscricao.matricula.pessoa.nome }}
              </span>
            </td>
            <td>
              <span class="d-flex align-center justify-center">
                {{ inscricao.matricula.pessoa.pessoaFisica.pai_nome || "-" }}
              </span>
            </td>
            <td>
              <span class="d-flex align-center justify-center">
                {{ inscricao.matricula.pessoa.pessoaFisica.mae_nome || "-" }}
              </span>
            </td>
            <td>
              <span>
                {{ getTelefones(inscricao.matricula.pessoa.telefones) }}
              </span>
            </td>
            <td>
              <span>
                {{ getEndereco(inscricao.matricula.pessoa.endereco) }}
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-col>

    <DialogInscricao
      v-if="showDialog"
      v-model="inscricaoSelected"
      :tipoStatus="tipoStatus"
      @save="onSaveInscricao($event)"
      @close="showDialog = false"
    />
  </v-row>
</template>

<script>
import DialogInscricao from "./DialogInscricao.vue";

const tipoStatus = [
  { label: "DEFERIDO", value: "DEFERIDO", color: "green" },
  { label: "PENDENTE", value: "PENDENTE", color: "grey" },
  { label: "ELIMINADO", value: "ELIMINADO", color: "red" },
  {
    label: "AGUARDANDO CORREÇÃO",
    value: "AGUARDANDO_CORRECAO",
    color: "orange",
  },
];

export default {
  props: {
    inscricoes: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    DialogInscricao,
  },

  data() {
    return {
      tipoStatus,
      inscricaoSelected: null,
      showDialog: false,

      headers: [
        {
          text: "Unidade Origem",
          align: "center",
          value: "unidadeOrigem.nomeCompleto",
        },
        { text: "Etapa", align: "center", value: "matricula.etapa.nome" },
        { text: "CPF", align: "center", value: "matricula.pessoa.cpf_cnpj" },
        {
          text: "Nome",
          align: "center",
          value: "matricula.pessoa.nome",
        },
        {
          text: "Nome - Pai",
          align: "center",
          value: "matricula.pessoa.paiNome",
        },
        {
          text: "Nome - Mãe",
          align: "center",
          value: "matricula.pessoa.maeNome",
        },
        {
          text: "Telefones",
          align: "center",
          value: "matricula.pessoa.telefone",
        },
        {
          text: "Endereço",
          align: "center",
          value: "matricula.pessoa.endereco",
        },
      ],
    };
  },

  methods: {
    imprimirEncaminhamento(inscricao) {
      this.$router.push(`/encaminhamento-plantao/${inscricao.id}`);
    },

    getTelefones(telefones) {
      // Se não possuir telefones, retorna uma string vazia
      if (!telefones || !telefones.length) {
        return "-";
      }
      return telefones
        .map((t) => t.numero)
        .join(", ")
        .trim();
    },

    getEndereco(endereco) {
      return `${endereco.logradouro}, ${endereco.numero ||
        "S/N"}, ${endereco.complemento || ""} - ${endereco.bairro}`;
    },

    onClickInscricao(inscricao) {
      this.inscricaoSelected = inscricao;
      this.showDialog = true;
    },

    onSaveInscricao(inscricao) {
      this.$emit("save", inscricao);
      this.showDialog = false;
      this.inscricaoSelected = null;
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
